<template>
    <div>
        <avatar :username="item.displayName" 
                :size="30" 
                :inline="true" 
                class="avatar mr-1">
        </avatar>
        <span class="mr-1">{{ item.displayName }}</span>
        <span v-if="item.duplicate">
            <small><em>({{ item.email }})</em></small>
        </span>
    </div>
</template>

<script>
import Avatar from 'vue-avatar';

export default {
    components: {
        Avatar
    },

    props: {
        item: {
            required: true
        }
    }
}
</script>
